<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:46:19
 * @LastEditTime: 2022-05-25 17:42:32
 * @LastEditors: yeqing
 * @Description: 企业基本信息组件
-->
<template>
  <div class="basicInfoModel">
    <a-form layout="horizontal">
      <a-form-item label="1、公司名称">
        <a-select
          show-search
          v-model="basicInfo.q411"
          :autoClearSearchValue="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="optionLoading ? undefined : null"
          @search="handleSearch"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
          style="width: 400px"
        >
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option
            v-for="(company, index) in companyList"
            :key="index"
            :value="company"
            >{{ company }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="2、成立日期">
        <a-date-picker
          style="width: 400px"
          placeholder
          :value="basicInfo.q412 ? moment(basicInfo.q412, dateFormat) : ''"
          @change="onChangeDate"
          :disabled="!isSelectDate"
        />
      </a-form-item>
      <a-form-item
        label="3、具有独立法人资格的中型、小型和微型企业"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q413">
          <a-radio value="没有">没有</a-radio>
          <a-radio value="有">有</a-radio>
        </a-radio-group>
        <svg-icon icon-class="right" class="right_icon"></svg-icon>
        <label class="link_text" @click="onSelfTest">企业规模类型自测</label>
      </a-form-item>
      <a-form-item
        label="4、是否符合城市战略定位和产业发展政策"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q414">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="5、主要产品(服务)所属领域">
        <a-cascader
          :options="optionList"
          placeholder
          @change="onChangeSelect"
          style="width: 300px"
          v-model="optionValue"
        />
      </a-form-item>
      <a-form-item
        label="6、企业近三年是否发生重大安全、重大质量事故、环境污染事故"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q416">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="7、企业是否发生偷税漏税或其他违法违规被处罚的情况"
        class="radio-box"
      >
        <a-radio-group name="radioGroup" v-model="basicInfo.q417">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="8、企业是否发生其他严重失信行为" class="radio-box">
        <a-radio-group name="radioGroup" v-model="basicInfo.q418">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div style="text-align: center; margin-top: 40px;">
        <a-button class="primary-btn pre-btn" @click="handlePre"
          >上一步</a-button
        >
        <a-button @click="handleNext" class="primary-btn">下一步</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { getCompanyInfo, getCorpInfo } from "@/api/enterpriseHighNew";
import { getReportName } from "@/api/enterpriseSpecial";
import { zjtxOptionData } from "@/utils/josnData";
import moment from "moment";
export default {
  name: "basicInfoModel",
  data() {
    return {
      isSelectDate: true,
      dateFormat: "YYYY-MM-DD",
      companyList: [],
      optionLoading: false,
      basicInfo: {
        q411: "",
        q412: "",
        q413: "",
        q414: "",
        q415: "",
        q416: "",
        q417: "",
        q418: "",
      },
      optionList: [],
      optionData: zjtxOptionData,
      q411: "", //公司名称暂存
      flag: true, //是否支持查询
      optionValue: [],
    };
  },
  created() {
    // 处理 optionList
    let arr = [];
    this.optionData.map((item, key) => {
      arr.push({
        label: item.label,
        value: item.label,
        children: [],
      });
      item.children.map((item1) => {
        arr[key].children.push({
          label: item1,
          value: item1,
        });
      });
    });
    this.optionList = arr;
    this.getRecordList();
    // 取缓存信息
    if (sessionStorage.getItem("basicInfo")) {
      this.basicInfo = JSON.parse(sessionStorage.getItem("basicInfo"));
      if (this.basicInfo.q415) {
        this.optionValue = this.basicInfo.q415.split("/");
      }
      sessionStorage.removeItem("basicInfo");
    }
  },
  methods: {
    moment,
    // 自测
    onSelfTest() {
      // 保存当前所填的信息
      sessionStorage.setItem("basicInfo", JSON.stringify(this.basicInfo));
      this.$router.push("/enterpriseScale?source=zjtx");
    },
    // 获取测评记录
    getRecordList() {
      let clientType =
        sessionStorage.getItem("page") == "gov"
          ? 1
          : sessionStorage.getItem("page") == "ICompany"
          ? 3
          : 2;
      getReportName({
        rankType: 4,
        clientType,
        keyWord:'北京'
      }).then((res) => {
        if (res.data.length > 6) {
          this.companyList = res.data.slice(0, 6);
        } else {
          this.companyList = res.data;
        }
      });
    },
    handleFocus() {
      // this.basicInfo.q411 = ''
      // this.basicInfo.q412 = ''
      this.isSelectDate = true;
    },
    handleBlur() {
      if (!this.basicInfo.q411) {
        this.basicInfo.q411 = this.q411;
      }
    },
    onChangeSelect(e) {
      this.basicInfo.q415 = e.join("/");
    },
    handleChange(value) {
      this.basicInfo.q411 = value;
      Object.assign(this, {
        companyList: [],
        optionLoading: false,
      });
      getCorpInfo({
        companyName: value,
      }).then((res) => {
        if (res.data.name) {
          if (res.data.companyProvince.indexOf("北京") === -1) {
            this.flag = false;
            this.$message.error("该测评暂不支持所在城市，陆续开通中，敬请期待");
            return;
          }
          this.flag = true;
          this.basicInfo.q412 = res.data.foundedTime;
          this.isSelectDate = false;
        } else {
          this.isSelectDate = true;
        }
      });
    },
    handleSearch(value) {
      this.optionLoading = true;
      if (value) {
        this.q411 = value;
      }
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyList = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    },

    onChangeDate(date, dateString) {
      this.basicInfo.q412 = dateString;
    },

    // 上一步
    handlePre() {
      this.$router.push("/enterpriseSpecial");
    },

    // 下一步
    handleNext(e) {
      e.preventDefault();
      if (!this.flag) {
        this.$message.error("该测评暂不支持所在城市，陆续开通中，敬请期待");
        return;
      }
      this.basicInfo.q412 = this.basicInfo.q412 ? this.basicInfo.q412 : "";
      this.$emit("changeTabKey", {
        name: "basicInfo",
        key: 2,
        data: this.basicInfo,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.basicInfoModel {
  margin-top: 30px;
  .right_icon {
    width: 12px;
    height: 10px;
    margin-right: 8px;
    margin-bottom: 2px;
  }
  .link_text {
    height: 14px;
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #0072f7;
    line-height: 14px;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #59a4ff;
    }
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .unit {
    width: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin: 0 6px 0 10px;
  }
}
</style>
